import { render, staticRenderFns } from "./VuePlayer.vue?vue&type=template&id=59c76b4f&scoped=true"
import script from "./VuePlayer.vue?vue&type=script&lang=js"
export * from "./VuePlayer.vue?vue&type=script&lang=js"
import style0 from "./VuePlayer.vue?vue&type=style&index=0&id=59c76b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c76b4f",
  null
  
)

export default component.exports